'use strict';

import React from 'react';
import dom from 'utils/dom';

export default React.createClass({

    displayName: 'OffcanvasToggle',

    propTypes: {},

    getInitialState() {
        return {
            winDimensions: dom.getWindowDimensions()
        };
    },


    componentDidMount() {

        window.addEventListener('resize', this.handleResize);
    },


    toggleOffcanvas(e) {

        e.preventDefault();
        var bodyEl = document.getElementsByTagName('body')[0];
        dom.toggleClass(bodyEl, 'offcanvas--active');
    },

    handleResize() {

        // Because iOS is firing some unexpected resize events we
        // must assure that the dimensions actually changed
        let win = dom.getWindowDimensions();
        if (win.x !== this.state.winDimensions.x) {
            this.setState({windDimensions: win});
            var bodyEl = document.getElementsByTagName('body')[0];
            dom.removeClass(bodyEl, 'offcanvas--active');
        }
    },


    render() {
        return (
            <div className="hamburger" onClick={this.toggleOffcanvas}>
                <div className="hamburger__content">
                    <i className="content__line content__line_1"></i>
                    <i className="content__line content__line_2"></i>
                    <i className="content__line content__line_3"></i>
                </div>
                <div className="hamburger__description">
                    Menu
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./static/app/offcanvas/offcanvasToggle.jsx